export default __webpack_public_path__ + "static/media/Customer_line.c70bfed6.svg";